<template>
  <div class="filters-box" v-show="isShow">
    <!-- eslint-disable-next-line vue/no-mutating-props -->
    <el-form :model.sync="model">
      <div class="filters-box-inner">
        <template v-for="(filter) in filterList">
          <!-- 下拉选择器 -->
          <div
            v-if="filter && filter.type === 'select'"
            class="filter-wrapper"
            v-show="typeof filter.isShow === 'undefined' || filter.isShow"
            :key="filter.name"
          >
            <p class="filter-label">{{filter.label}}</p>
            <el-form-item label="">
              <!-- eslint-disable-next-line vue/no-mutating-props -->
              <el-select v-model="model[filter.name]" :clearable="false" :placeholder="filter.placeholder || '请选择'">
                <el-option v-for="(option) in filter.options" :label="option.label" :value="option.value" :key="option.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 时间范围选择器 -->
          <div
            v-if="filter && filter.type === 'dateRange'"
            class="filter-wrapper"
            v-show="typeof filter.isShow === 'undefined' || filter.isShow"
            :key="filter.name"
          >
            <p class="filter-label">{{filter.label}}</p>
            <el-form-item label="">
              <!-- eslint-disable-next-line vue/no-mutating-props -->
              <QS-date-picker v-model="model[filter.name]"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="{
                  ...getDefaultPickerOptions(filter),
                  ...(filter.pickerOptions || {})
                }"
                :clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </QS-date-picker>
            </el-form-item>
          </div>
          <!-- 级联选择器 -->
          <div
            v-if="filter && filter.type === 'cascader'"
            class="filter-wrapper"
            v-show="typeof filter.isShow === 'undefined' || filter.isShow"
            :key="filter.name"
          >
            <p class="filter-label">{{filter.label}}</p>
            <el-form-item label="">
              <!-- eslint-disable-next-line vue/no-mutating-props -->
              <el-cascader v-model="model[filter.name]"
                filterable
                clearable
                show-all-levels
                :placeholder="filter.placeholder || '全部'"
                :options="filter.options"
                :props="{
                  emitPath: false,
                  multiple: false,
                }">
              </el-cascader>
            </el-form-item>
          </div>
          <!-- 部门选择器 -->
          <div
            v-if="filter && filter.type === 'DeptSelect'"
            class="filter-wrapper"
            v-show="typeof filter.isShow === 'undefined' || filter.isShow"
            :key="filter.name"
          >
            <p class="filter-label">{{filter.label}}</p>
            <el-form-item label="">
              <!-- eslint-disable-next-line vue/no-mutating-props -->
              <DeptSelect v-model="model[filter.name]" :clearable="false" filterable />
            </el-form-item>
          </div>
        </template>
      </div>
    </el-form>
  </div>
</template>
<script>
import DeptSelect from '@/components/DeptSelect/index.vue'

export default {
  components: {
    DeptSelect,
  },
  props: {
    filterList: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isShow() {
      return !this.filterList.every((item) => item.isShow === false)
    },
  },
  watch: {
    model: {
      handler(val) {
        this.$emit('change', val)
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    getDefaultPickerOptions(data) {
      const { t_1 } = data
      return {
        shortcuts: [{
          text: '近7天',
          onClick(picker) {
            const end = t_1 ? new Date(new Date().getTime() - 3600 * 1000 * 24) : new Date()
            const start = t_1 ? new Date(new Date().getTime() - 3600 * 1000 * 24) : new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '近30天',
          onClick(picker) {
            const end = t_1 ? new Date(new Date().getTime() - 3600 * 1000 * 24) : new Date()
            const start = t_1 ? new Date(new Date().getTime() - 3600 * 1000 * 24) : new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '近90天',
          onClick(picker) {
            const end = t_1 ? new Date(new Date().getTime() - 3600 * 1000 * 24) : new Date()
            const start = t_1 ? new Date(new Date().getTime() - 3600 * 1000 * 24) : new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '近180天',
          onClick(picker) {
            const end = t_1 ? new Date(new Date().getTime() - 3600 * 1000 * 24) : new Date()
            const start = t_1 ? new Date(new Date().getTime() - 3600 * 1000 * 24) : new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '近360天',
          onClick(picker) {
            const end = t_1 ? new Date(new Date().getTime() - 3600 * 1000 * 24) : new Date()
            const start = t_1 ? new Date(new Date().getTime() - 3600 * 1000 * 24) : new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 360)
            picker.$emit('pick', [start, end])
          },
        }],
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.filters-box {
  .filters-box-inner {
    display: flex;
    padding: 16px;
    background: #F7F8FA;
    border-radius: 6px;
    .filter-wrapper {
      margin-right: 12px;
      .filter-label {
        margin: 0;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        color: #606266;
      }
      ::v-deep .el-form-item {
        margin: 2px 0 0 0;
      }
    }
  }
}
</style>
